/**
 * Feature palette aggregation.
 *
 * Every feature drops a `palette.ts` and registers it here. Adding a new
 * feature is a 2-line change: import + push into FEATURES.
 *
 * The ordering doesn't matter for ranking (everything is scored against
 * the query) but it's roughly "user-facing → settings → diagnostics" so
 * a human grepping the list reads well.
 */
import type { FeaturePalette } from "../types";

import { adminPalette } from "@/features/admin/palette";
import { capturePalette } from "@/features/capture/palette";
import { appBlockingPalette } from "@/features/app-blocking/palette";
import { appUsagePalette } from "@/features/app-usage/palette";
import { chatPalette } from "@/features/chat/palette";
import { financePalette } from "@/features/finance/palette";
import { inputTypesPalette } from "@/features/input-types/palette";
import { meditationPalette } from "@/features/meditation/palette";
import { drivingPalette } from "@/features/driving/palette";
import { mentalMathPalette } from "@/features/mental-math/palette";
import { nbackPalette } from "@/features/nback/palette";
import { relationalPalette } from "@/features/relational/palette";
import { batteryPalette } from "@/features/battery/palette";
import { notesPalette } from "@/features/notes/palette";
import { readingPalette } from "@/features/reading/palette";
import { srsPalette } from "@/features/srs/palette";
import { tasksPalette } from "@/features/tasks/palette";

export const FEATURE_PALETTES: FeaturePalette[] = [
  chatPalette,
  capturePalette,
  notesPalette,
  readingPalette,
  srsPalette,
  tasksPalette,
  financePalette,
  inputTypesPalette,
  mentalMathPalette,
  nbackPalette,
  relationalPalette,
  batteryPalette,
  meditationPalette,
  drivingPalette,
  appUsagePalette,
  appBlockingPalette,
  adminPalette,
];
